var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgXIcon = function SvgXIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08231 7L13.7951 2.28732C14.0677 2.01477 14.0677 1.57246 13.7951 1.29946L12.7001 0.204419C12.4275 -0.0681396 11.9852 -0.0681396 11.7122 0.204419L6.99978 4.91753L2.28696 0.204856C2.01439 -0.067702 1.57207 -0.067702 1.29907 0.204856L0.204425 1.29946C-0.0681417 1.57202 -0.0681417 2.01433 0.204425 2.28732L4.91725 7L0.204425 11.7127C-0.0681417 11.9852 -0.0681417 12.4275 0.204425 12.7005L1.2995 13.7956C1.57207 14.0681 2.01439 14.0681 2.2874 13.7956L6.99978 9.08247L11.7126 13.7951C11.9852 14.0677 12.4275 14.0677 12.7005 13.7951L13.7956 12.7001C14.0681 12.4275 14.0681 11.9852 13.7956 11.7122L9.08231 7Z",
    fill: "#444444"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/x-icon.2f1a09ac.svg";
export { ForwardRef as ReactComponent };